"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.maybeHijackSafeAreaProvider = maybeHijackSafeAreaProvider;
function maybeHijackSafeAreaProvider(type) {
    return type;
}
//# sourceMappingURL=react-native-safe-area-context.js.map